import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconCalendar, IconGear, IconImage, IconUser, IconVideo, IconVolumeUp } from '../../../base/icons/svg';
import DialogWithTabs from '../../../base/ui/components/web/DialogWithTabs';
import { isCalendarEnabled } from '../../../calendar-sync/functions.web';
import { submitAudioDeviceSelectionTab, submitVideoDeviceSelectionTab } from '../../../device-selection/actions.web';
import VideoDeviceSelection from '../../../device-selection/components/VideoDeviceSelection.web';
import { getAudioDeviceSelectionDialogProps, getVideoDeviceSelectionDialogProps } from '../../../device-selection/functions.web';
import { checkBlurSupport, checkVirtualBackgroundEnabled } from '../../../virtual-background/functions';
import { iAmVisitor } from '../../../visitors/functions';
import { submitMoreTab, submitProfileTab, submitVirtualBackgroundTab } from '../../actions';
import { SETTINGS_TABS } from '../../constants';
import { getModeratorTabProps, getMoreTabProps, getNotificationsMap, getProfileTabProps, getVirtualBackgroundTabProps } from '../../functions';
import CalendarTab from './CalendarTab';
import VirtualBackgroundTab from './VirtualBackgroundTab';
import MoreTab from "../../../../11sight/features/settings/components/MoreTab";
import ProfileTab from "../../../../11sight/features/settings/components/ProfileTab";
import AudioDevicesSelection from "../../../../11sight/features/device-selection/components/AudioDevicesSelection";
const useStyles = makeStyles()(() => {
    return {
        settingsDialog: {
            display: 'flex',
            width: '100%'
        }
    };
});
const SettingsDialog = ({ _tabs, defaultTab, dispatch }) => {
    const { classes } = useStyles();
    const correctDefaultTab = _tabs.find(tab => tab.name === defaultTab)?.name;
    const tabs = _tabs.map(tab => {
        return {
            ...tab,
            className: `settings-pane ${classes.settingsDialog}`,
            submit: (...args) => tab.submit
                && dispatch(tab.submit(...args))
        };
    });
    return (React.createElement(DialogWithTabs, { className: 'settings-dialog', defaultTab: correctDefaultTab, tabs: tabs, titleKey: 'settings.title' }));
};
function _mapStateToProps(state, ownProps) {
    const { isDisplayedOnWelcomePage } = ownProps;
    const configuredTabs = interfaceConfig.SETTINGS_SECTIONS || [];
    const showDeviceSettings = configuredTabs.includes("devices");
    const moreTabProps = getMoreTabProps(state);
    const moderatorTabProps = getModeratorTabProps(state);
    const { showModeratorSettings } = moderatorTabProps;
    const showMoreTab = configuredTabs.includes("more");
    const showProfileSettings = configuredTabs.includes("profile") && !state["features/base/config"].disableProfile;
    const showCalendarSettings = configuredTabs.includes("calendar") && isCalendarEnabled(state);
    const enabledNotifications = getNotificationsMap(state);
    const virtualBackgroundSupported = checkBlurSupport();
    const enableVirtualBackground = checkVirtualBackgroundEnabled(state);
    const tabs = [];
    const _iAmVisitor = iAmVisitor(state);
    if (showDeviceSettings) {
        tabs.push({
            name: SETTINGS_TABS.AUDIO,
            component: AudioDevicesSelection,
            labelKey: "settings.audio",
            props: getAudioDeviceSelectionDialogProps(state, isDisplayedOnWelcomePage),
            propsUpdateFunction: (tabState, newProps) => {
                return {
                    ...newProps,
                    noiseSuppressionEnabled: tabState.noiseSuppressionEnabled,
                    selectedAudioInputId: tabState.selectedAudioInputId,
                    selectedAudioOutputId: tabState.selectedAudioOutputId
                };
            },
            submit: (newState) => submitAudioDeviceSelectionTab(newState, isDisplayedOnWelcomePage),
            icon: IconVolumeUp
        });
        !_iAmVisitor && tabs.push({
            name: SETTINGS_TABS.VIDEO,
            component: VideoDeviceSelection,
            labelKey: "settings.video",
            props: getVideoDeviceSelectionDialogProps(state, isDisplayedOnWelcomePage),
            propsUpdateFunction: (tabState, newProps) => {
                return {
                    ...newProps,
                    currentFramerate: tabState?.currentFramerate,
                    localFlipX: tabState.localFlipX,
                    selectedVideoInputId: tabState.selectedVideoInputId
                };
            },
            submit: (newState) => submitVideoDeviceSelectionTab(newState, isDisplayedOnWelcomePage),
            icon: IconVideo
        });
    }
    if (virtualBackgroundSupported && !_iAmVisitor && enableVirtualBackground) {
        tabs.push({
            name: SETTINGS_TABS.VIRTUAL_BACKGROUND,
            component: VirtualBackgroundTab,
            labelKey: "virtualBackground.title",
            props: getVirtualBackgroundTabProps(state, isDisplayedOnWelcomePage),
            propsUpdateFunction: (tabState, newProps, tabStates) => {
                const videoTabState = tabStates[tabs.findIndex(tab => tab.name === SETTINGS_TABS.VIDEO)];
                return {
                    ...newProps,
                    selectedVideoInputId: videoTabState?.selectedVideoInputId || newProps.selectedVideoInputId,
                    options: tabState.options
                };
            },
            submit: (newState) => submitVirtualBackgroundTab(newState),
            cancel: () => {
                const { options } = getVirtualBackgroundTabProps(state, isDisplayedOnWelcomePage);
                return submitVirtualBackgroundTab({
                    options
                }, true);
            },
            icon: IconImage
        });
    }
    if (showProfileSettings) {
        tabs.push({
            name: SETTINGS_TABS.PROFILE,
            component: ProfileTab,
            labelKey: "profile.title",
            props: getProfileTabProps(state),
            submit: submitProfileTab,
            icon: IconUser
        });
    }
    if (showCalendarSettings && !_iAmVisitor) {
        tabs.push({
            name: SETTINGS_TABS.CALENDAR,
            component: CalendarTab,
            labelKey: "settings.calendar.title",
            icon: IconCalendar
        });
    }
    if (showMoreTab && !_iAmVisitor) {
        tabs.push({
            name: SETTINGS_TABS.MORE,
            component: MoreTab,
            labelKey: "settings.more",
            props: moreTabProps,
            propsUpdateFunction: (tabState, newProps) => {
                return {
                    ...newProps,
                    currentLanguage: tabState?.currentLanguage,
                    hideSelfView: tabState?.hideSelfView,
                    showPrejoinPage: tabState?.showPrejoinPage,
                    maxStageParticipants: tabState?.maxStageParticipants
                };
            },
            submit: submitMoreTab,
            icon: IconGear
        });
    }
    return {
        _tabs: tabs
    };
}
export default connect(_mapStateToProps)(SettingsDialog);
